import { AUTH_ACTIONS } from "../actions/authActions";

const initState = {
  authorized: false,
  errorTitle: "",
  errorDesc: ""
};

const authReducer = (auth = initState, action) => {
  switch (action.type) {
    case AUTH_ACTIONS.SET_ERROR: {
      console.log(" in authReducer ", action.payload.errorTitle);
      localStorage.setItem("error", action.payload.errorTitle);
      return action.payload;
    }
    case AUTH_ACTIONS.REMOVE_ERROR: {
      localStorage.removeItem("error");
      return initState;
    }

    case AUTH_ACTIONS.AUTHENTICATE: {
      return initState;
    }

    default:
      return auth;
  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/authReducer.js